import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import CustomImage from '../../../v2-components/Antd/Image';
import { Icons } from '../constant/icons.constant';
import { isDateInRange } from '../../../v2-config/utils/is-date-in-range.util';

export const handleTagIcon = (product, width) => {
	if (product.validate_recipe === 'TRUE') {
		return null;
	}
	if (product.promotions === null) {
		return null;
	}
	if (!isDateInRange(product?.promotions?.date_start, product?.promotions?.date_end)) {
		return null;
	}

	if (width) {
		return <CustomImage width={width} src={Icons[Enviroment.COUNTRY].promotion_tag} />;
	}
	return <CustomImage src={Icons[Enviroment.COUNTRY].promotion_tag} />;
};
